// custom-gsap.js
// Homepage scroll animations (heroes, Real-Time AI Feedback, golf pin).
// 首页滚动动画总控（Hero、实时 AI 反馈、高尔夫钉住序列）。
(function() {
  // 等待 GSAP / ScrollTrigger 就绪
  function whenGSAPReady(callback) {
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      callback();
    } else {
      setTimeout(function() { whenGSAPReady(callback); }, 50);
    }
  }

  // 总控：初始化所有组件
  function initAllAnimations() {

    ScrollTrigger.config({ 
    ignoreMobileResize: true 
  });
    
    gsap.registerPlugin(ScrollTrigger);

    initDataHero();
    initPersHero();
    initAIFeedback();     // 组件3 (Real-Time AI Feedback)
    initGolfCarousel();   // 组件4 (Golf Accessibility Pin)

    // // 统一排序，避免多个 ScrollTrigger 的执行顺序冲突
     ScrollTrigger.sort();
    // // 延迟刷新，确保所有图片、字体等加载完成后的布局稳定
 
       ScrollTrigger.refresh();

    // 解决: 页面中视频在 resize 时因 ScrollTrigger 刷新导致 DOM 重构而重新播放的问题
    var savedVideos = [];
    ScrollTrigger.addEventListener("refreshInit", function() {
      savedVideos = [];
      document.querySelectorAll('video').forEach(function(vid) {
        savedVideos.push({
          el: vid,
          time: vid.currentTime,
          playing: !vid.paused
        });
      });
    });
    ScrollTrigger.addEventListener("refresh", function() {
      savedVideos.forEach(function(state) {
        if (state.el) {
          if (state.el.readyState > 0) {
            state.el.currentTime = state.time;
            if (state.playing) {
              var playPromise = state.el.play();
              if (playPromise !== undefined) playPromise.catch(function(){});
            }
          } else {
            state.el.addEventListener('loadedmetadata', function restoreTime() {
              state.el.removeEventListener('loadedmetadata', restoreTime);
              state.el.currentTime = state.time;
              if (state.playing) {
                var playPromise = state.el.play();
                if (playPromise !== undefined) playPromise.catch(function(){});
              }
            }, { once: true });
          }
        }
      });
    });

    function emitScrollLayoutChanged() {
      try {
        window.dispatchEvent(new CustomEvent('lp-scroll-layout-changed'));
      } catch (e) {}
    }

    // Recalculate pin positions after late layout shifts above the golf section.
    // This keeps its stored start position aligned with the visible pin spacer.
    var layoutRefreshTimer;
    function scheduleLayoutRefresh() {
      // Skip while anchor-locked — pin refresh yanks scroll to data/pers.
      // Refresh runs after lp-jump-settle-end (user scroll releases the lock).
      // 锚点锁定期间跳过：钉住 refresh 会把滚动拽回 data/pers。
      // 用户滚动解锁并触发 lp-jump-settle-end 后再 refresh。
      if (window.__lpNavJumping || window.__lpJumpTarget) return;
      window.clearTimeout(layoutRefreshTimer);
      layoutRefreshTimer = window.setTimeout(function() {
        if (window.__lpNavJumping || window.__lpJumpTarget) return;
        ScrollTrigger.sort();
        ScrollTrigger.refresh();
        emitScrollLayoutChanged();
      }, 100);
    }

    ScrollTrigger.addEventListener('refresh', function() {
      emitScrollLayoutChanged();
    });

    window.addEventListener('lp-jump-settle-end', function() {
      window.setTimeout(scheduleLayoutRefresh, 50);
    });

    // Fonts can change the height of sections before the golf pin after load.
    var fontsReady = document.fonts && document.fonts.ready
      ? document.fonts.ready
      : Promise.resolve();
    fontsReady.then(function() {
      window.requestAnimationFrame(function() {
        window.requestAnimationFrame(scheduleLayoutRefresh);
      });
    });

    // Lazy media can resize preceding sections after GSAP has already measured.
    // Do not observe the golf section itself: its pin spacer would cause refresh loops.
    var golfSection = document.querySelector('.js-golf-carousel');
    var golfHost = golfSection && (golfSection.closest('.shopify-section') || golfSection);
    if (golfHost && typeof ResizeObserver !== 'undefined') {
      var precedingSections = [];
      var precedingSection = golfHost.previousElementSibling;
      while (precedingSection) {
        precedingSections.push(precedingSection);
        precedingSection = precedingSection.previousElementSibling;
      }

      if (precedingSections.length) {
        var precedingLayoutObserver = new ResizeObserver(scheduleLayoutRefresh);
        precedingSections.forEach(function(section) {
          precedingLayoutObserver.observe(section);
        });
      }
    }

    var fitRefreshTimer;
    document.addEventListener('lp:viewport-fit', function() {
      window.clearTimeout(fitRefreshTimer);
      fitRefreshTimer = window.setTimeout(function() {
        if (window.__lpNavJumping || window.__lpJumpTarget) return;
        ScrollTrigger.refresh();
        emitScrollLayoutChanged();
      }, 100);
    });

    // Signal nav/hash jumps that pin spacers are measured.
    // 通知分区导航 / 锚点：钉住占位已测量完毕。
    window.setTimeout(function() {
      window.__lpGsapReady = true;
      try {
        window.dispatchEvent(new CustomEvent('lp-gsap-ready'));
      } catch (e) {}
      if (window.__lpNavJumping || window.__lpJumpTarget) return;
      ScrollTrigger.sort();
      ScrollTrigger.refresh();
      emitScrollLayoutChanged();
    }, 180);
  }

      // ==========================================
      // 1. Data Hero 动画配置
      // ==========================================
      function initDataHero() {
        const sections = document.querySelectorAll('.js-data-hero');
        
        sections.forEach(function(section) {
          if (section.classList.contains('gsap-data-init')) return;
          section.classList.add('gsap-data-init');

          // 严格抓取自己作用域下的类名
          const stickyContainer = section.querySelector('.data-hero-sticky-container');
          const titleGroup = section.querySelector('.data-hero-title-group');
          const overlay = section.querySelector('.data-hero-overlay');
          
          if (!stickyContainer || !titleGroup || !overlay) return;

          gsap.timeline({
            scrollTrigger: {
              trigger: stickyContainer,
              start: "top top",
              end: "+=100%",
              pin: true,
              anticipatePin: 1,
              scrub: 0.2,
              invalidateOnRefresh: false,
              refreshPriority: 100
            }
          })
          .to(titleGroup, { y: -50, opacity: 0, duration: 1.2 }, 0)
          .to(overlay, { opacity: 0, duration: 1.2 }, 0);
        });
      }

      // ==========================================
      // 2. Personalization Hero 动画配置
      // ==========================================
      function initPersHero() {
        const sections = document.querySelectorAll('.js-pers-hero');
        
        sections.forEach(function(section) {
          if (section.classList.contains('gsap-pers-init')) return;
          section.classList.add('gsap-pers-init');

          // 严格抓取自己作用域下的类名
          const stickyContainer = section.querySelector('.pers-hero-sticky-container');
          const titleGroup = section.querySelector('.pers-hero-title-group');
          const overlay = section.querySelector('.pers-hero-overlay');
          
          if (!stickyContainer || !titleGroup || !overlay) return;

          // 即使动画一模一样，写在各自的函数里未来修改也非常安全
          gsap.timeline({
            scrollTrigger: {
              trigger: stickyContainer,
              start: "top top",
              end: "+=100%",
              pin: true,
              anticipatePin: 1,
              scrub: 0.2,
              invalidateOnRefresh: false,
              refreshPriority: 100
            }
          })
          .to(titleGroup, { y: -50, opacity: 0, duration: 1.2 }, 0)
          .to(overlay, { opacity: 0, duration: 1.2 }, 0);
        });
      }
  // ========== 组件3：Real-Time AI Feedback ==========
  function initAIFeedback() {
    var sections = document.querySelectorAll('.js-rt-ai-feedback');
    sections.forEach(function(section) {
      if (section.classList.contains('gsap-ai-initialized')) return;
      section.classList.add('gsap-ai-initialized');

      var header = section.querySelector('.rt-feedback__header');
      var conversation = section.querySelector('.rt-feedback__conversation');
      var scrollArea = section.querySelector('.rt-feedback__scroll');
      var sticky = section.querySelector('.rt-feedback__sticky');
      var track = section.querySelector('[data-chat-track]');
      var viewport = section.querySelector('[data-chat-viewport]');
      var footer = section.querySelector('.rt-feedback__footer');
      var bubbles = track ? Array.prototype.slice.call(track.querySelectorAll('.rt-feedback__bubble')) : [];

      if (!header || !conversation || !scrollArea || !sticky || !track || !viewport || !bubbles.length) return;

      var mm = gsap.matchMedia();

      // 工具函数：计算轨道可滚动距离（保证末尾气泡完整进入视口）
      function getTrackTravel(endGap) {
        if (!track || !viewport) return 0;
        return Math.max(track.scrollHeight - viewport.clientHeight + endGap, 0);
      }

      // 第 index 个气泡底部相对 track 内容顶部的距离
      function getBubbleBottom(index) {
        var trackGap = parseFloat(window.getComputedStyle(track).gap) || 0;
        var trackPadTop = parseFloat(window.getComputedStyle(track).paddingTop) || 0;
        var bottom = trackPadTop;
        for (var i = 0; i <= index; i++) {
          bottom += bubbles[i].offsetHeight;
          if (i < index) bottom += trackGap;
        }
        return bottom;
      }

      // 滚动到刚好完整显示第 index 个气泡（贴齐视口底部 + 内边距）
      function getYToRevealBubble(index, endGap) {
        if (!track || !viewport || !bubbles[index]) return 0;
        var paddingBottom = Math.max(endGap || 0, 12);
        var targetY = getBubbleBottom(index) - viewport.clientHeight + paddingBottom;
        var maxY = getTrackTravel(endGap);
        return Math.max(0, Math.min(targetY, maxY));
      }

      // 重置气泡初始状态
      function setBubbleStates() {
        bubbles.forEach(function(bubble) {
          var isLeft = bubble.classList.contains('rt-feedback__bubble--left');
          gsap.set(bubble, {
            opacity: 0,
            y: 24,
            x: isLeft ? -30 : 30,
            scale: 0.985,
            transformOrigin: '50% 50%'
          });
        });
      }

      // 创建聊天气泡时间线
      function buildChatTimeline(config) {
        setBubbleStates();

        var endGap = config.endGap != null ? config.endGap : 24;
        var introStart = 1.0;
        var bubbleStep = config.bubbleStep;
        var revealDuration = config.bubbleRevealDuration;
        var pushDuration = config.pushDuration;

        // Header 初始位置（居中偏下）
        var headerStartY = 0;
        if (sticky) {
          headerStartY = (sticky.clientHeight / 2) - header.offsetTop - (header.offsetHeight / 2);
        }

        gsap.set(header, { y: Math.max(headerStartY, 0) });
        // The conversation is centered with inset-inline/margins in CSS.
        // Do not use xPercent here: GSAP transform ownership shifts it left in Safari.
        gsap.set(conversation, { y: 24, opacity: 0 });
        gsap.set(viewport, { y: 14, opacity: 0 });
        gsap.set(track, { y: 0 });

        var maxY = config.moveTrack ? getTrackTravel(endGap) : 0;
        var totalScroll =
          (window.innerHeight * config.scrollMultiplier) +
          (bubbles.length * config.perMessageScroll) +
          maxY +
          config.extraScroll +
          320;

        var tl = gsap.timeline({
          scrollTrigger: {
            trigger: scrollArea,
            start: config.start,
            end: function() {
              var travel = config.moveTrack ? getTrackTravel(endGap) : 0;
              return '+=' + Math.round(
                (window.innerHeight * config.scrollMultiplier) +
                (bubbles.length * config.perMessageScroll) +
                travel +
                config.extraScroll +
                320
              );
            },
            scrub: config.scrub,
            pin: config.pin,
            anticipatePin: 1,
            invalidateOnRefresh: true,
            // Keep pin width tied to layout width (not 100vw) to avoid L/R crop drift.
            // pin 宽度跟布局走，避免 100vw/滚动条导致左右裁切不一致。
            pinSpacing: true
          }
        });

        // 整体入场：header 上移，对话区淡入
        tl.to(header, { y: 0, ease: 'none', duration: 1.0 }, 0)
          .to(conversation, { y: 0, opacity: 1, ease: 'none', duration: 0.9 }, 0.08)
          .to(viewport, { y: 0, opacity: 1, ease: 'none', duration: 0.9 }, 0.16);

        // 逐个气泡出现；轨道始终滚到让当前气泡完整可见（适配任意视口高度）
        bubbles.forEach(function(bubble, index) {
          var bubbleStart = introStart + (index * bubbleStep);
          var isLast = index === bubbles.length - 1;

          tl.to(bubble, {
            opacity: 1,
            y: 0,
            x: 0,
            scale: 1,
            duration: revealDuration,
            ease: 'power2.out'
          }, bubbleStart);

          if (config.moveTrack) {
            (function(capturedIndex, capturedIsLast) {
              tl.to(track, {
                y: function() {
                  var y = getYToRevealBubble(capturedIndex, endGap);
                  if (capturedIsLast) {
                    y = Math.max(y, getTrackTravel(endGap));
                  }
                  return -y;
                },
                ease: 'none',
                duration: pushDuration
              }, bubbleStart + (revealDuration * 0.18));
            })(index, isLast);
          }
        });

        tl.to({}, { duration: config.tailHold }, '+=0');
      }

      // 桌面端配置
      mm.add('(min-width: 1025px)', function() {
        buildChatTimeline({
          start: 'top top',
          scrub: 1.15,
          pin: true,
          moveTrack: true,
          bubbleStep: 0.66,
          bubbleRevealDuration: 0.3,
          pushDuration: 0.58,
          tailHold: 0.5,
          scrollMultiplier: 1.5,
          perMessageScroll: 200,
          extraScroll: 0,
          endGap: 28
        });
      });

      // 平板端配置
      mm.add('(min-width: 768px) and (max-width: 1024px)', function() {
        buildChatTimeline({
          start: 'top top',
          scrub: 1.0,
          pin: true,
          moveTrack: true,
          bubbleStep: 0.55,
          bubbleRevealDuration: 0.28,
          pushDuration: 0.5,
          tailHold: 0.6,
          scrollMultiplier: 1.35,
          perMessageScroll: 180,
          extraScroll: 80,
          endGap: 24
        });
      });

      // 手机端配置
      mm.add('(max-width: 767px)', function() {
        buildChatTimeline({
          start: 'top top',
          scrub: 1.15,
          pin: true,
          moveTrack: true,
          bubbleStep: 0.66,
          bubbleRevealDuration: 0.3,
          pushDuration: 0.58,
          tailHold: 0.5,
          scrollMultiplier: 1.5,
          perMessageScroll: 200,
          extraScroll: 0,
          endGap: 20
        });
      });
    });
  }

  // ========== 组件4：Golf Accessibility Pin ==========
  function initGolfCarousel() {
    var sections = document.querySelectorAll('.js-golf-carousel');
    sections.forEach(function(section) {
      if (section.classList.contains('gsap-golf-initialized')) return;
      section.classList.add('gsap-golf-initialized');

      // 从组件预加载的数据中获取资源
      var data = section.golfData;
      if (!data || !data.video) return;

      var video = data.video;
      var frameCount = data.frameCount || 50;
      var fps = data.fps || 25;

      var pageWrapper = section.querySelector('.golf-pin-wrapper');
      var glowImages = Array.from(section.querySelectorAll('.glow-img'));
      var orangeTrack = section.querySelector('#orange-track');
      if (!orangeTrack || !pageWrapper) return;

      var trackLength = orangeTrack.getTotalLength();
      var groups = [
        section.querySelector('#group-0'),
        section.querySelector('#group-1'),
        section.querySelector('#group-2')
      ];

      var state = { currentStage: 0 };
      var currentFrame = -1;
      var seekBusy = false;
      var pendingFrame = -1;

      // Scroll progress → discrete video frame via currentTime
      function scrubToFrame(index) {
        if (!video) return;
        index = Math.max(0, Math.min(frameCount - 1, index));
        pendingFrame = index;
        if (seekBusy) return;
        if (index === currentFrame) return;

        var duration = video.duration;
        if (!isFinite(duration) || duration <= 0) return;

        var targetTime = Math.min(duration - 0.001, index / fps);
        if (Math.abs(video.currentTime - targetTime) < 0.001) {
          currentFrame = index;
          return;
        }

        seekBusy = true;
        currentFrame = index;
        try {
          video.currentTime = targetTime;
        } catch (e) {
          seekBusy = false;
        }
      }

      video.addEventListener('seeked', function() {
        seekBusy = false;
        if (pendingFrame >= 0 && pendingFrame !== currentFrame) {
          scrubToFrame(pendingFrame);
        }
      });

      // 更新滑块组在 SVG 轨迹上的位置
      function updateCarouselPositions() {
        var stageSpacing = 0.3;
        groups.forEach(function(group, i) {
          var progress = 0.5 + (i - state.currentStage) * stageSpacing;
          if (progress >= 0 && progress <= 1) {
            var point = orangeTrack.getPointAtLength(progress * trackLength);
            var distance = Math.abs(progress - 0.5);
            var opacity = Math.pow(Math.max(0, 1 - distance / stageSpacing), 1.5);
            var scale = 0.85 + (1 - distance / stageSpacing) * 0.15;
            // Use SVG user-space coordinates so the marker stays centered when
            // the responsive SVG is scaled to fit the viewport.
            gsap.set(group, {
              attr: {
                transform: 'translate(' + point.x + ' ' + point.y + ') scale(' + scale + ')'
              },
              opacity: opacity
            });
          } else {
            gsap.set(group, { opacity: 0 });
          }
        });
      }

      // 初始状态
      gsap.set(glowImages, { opacity: 0 });
      gsap.set(glowImages[0], { opacity: 1 });

      // Keep animation order stable even though mobile groups cards into visual columns.
      var cards = Array.from({ length: 8 }, function(_, index) {
        return section.querySelector('.card-' + (index + 1));
      }).filter(Boolean);
      gsap.set(cards, { opacity: 0, y: 40, scale: 0.95 });
      gsap.set([cards[0], cards[1]], { opacity: 1, y: 0, scale: 1 });

      // Distance (Carry) + Club Speed: 3 stage images per card, crossfade with level
      var carryImgs = Array.from(section.querySelectorAll('.card-1 .stage-img'));
      var speedImgs = Array.from(section.querySelectorAll('.card-2 .stage-img'));
      gsap.set(carryImgs.concat(speedImgs), { opacity: 0 });
      if (carryImgs[0]) gsap.set(carryImgs[0], { opacity: 1 });
      if (speedImgs[0]) gsap.set(speedImgs[0], { opacity: 1 });

      updateCarouselPositions();

      var scrubTrigger = null;

      function scrubFromProgress(progress) {
        var frame = Math.floor(progress * (frameCount - 1));
        scrubToFrame(frame);
      }

      // Video may still be lazy-loading when GSAP inits — sync once metadata is ready
      function onVideoReady() {
        var progress = scrubTrigger ? scrubTrigger.progress : 0;
        currentFrame = -1;
        scrubFromProgress(progress);
      }
      if (video.readyState >= 1) {
        onVideoReady();
      } else {
        video.addEventListener('loadedmetadata', onVideoReady, { once: true });
      }

      function addGolfTweens(tl) {
        // 背景光晕切换
        tl.to(glowImages[0], { opacity: 0, duration: 1 }, 0.5)
          .fromTo(glowImages[1], { opacity: 0 }, { opacity: 1, duration: 1 }, 0.5)
          .to(glowImages[1], { opacity: 0, duration: 1 }, 1.5)
          .fromTo(glowImages[2], { opacity: 0 }, { opacity: 1, duration: 1 }, 1.5);

        // Distance / Club Speed stage image crossfade (Beginner → Intermediate → Advanced)
        if (carryImgs.length === 3 && speedImgs.length === 3) {
          tl.to(carryImgs[0], { opacity: 0, duration: 1 }, 0.5)
            .fromTo(carryImgs[1], { opacity: 0 }, { opacity: 1, duration: 1 }, 0.5)
            .to(carryImgs[1], { opacity: 0, duration: 1 }, 1.5)
            .fromTo(carryImgs[2], { opacity: 0 }, { opacity: 1, duration: 1 }, 1.5)
            .to(speedImgs[0], { opacity: 0, duration: 1 }, 0.5)
            .fromTo(speedImgs[1], { opacity: 0 }, { opacity: 1, duration: 1 }, 0.5)
            .to(speedImgs[1], { opacity: 0, duration: 1 }, 1.5)
            .fromTo(speedImgs[2], { opacity: 0 }, { opacity: 1, duration: 1 }, 1.5);
        }

        // 卡片逐个显示
        tl.to(cards.slice(2, 4), {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 0.6,
          stagger: 0.15,
          ease: 'back.out(1.7)'
        }, 0.7)
        .to(cards.slice(4, 8), {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 0.5,
          stagger: 0.12
        }, 1.5);
      }

      // Pin the inner shell on both breakpoints (CSS sticky fails under theme ancestors).
      // 两端都钉住内部壳层（主题祖先节点会使 CSS sticky 失效）。
      var mm = gsap.matchMedia();

      function buildGolfPin(vars) {
        var tl = gsap.timeline({
          scrollTrigger: {
            trigger: pageWrapper,
            start: 'top top',
            end: '+=2500',
            pin: true,
            anticipatePin: vars.anticipatePin,
            scrub: vars.scrub,
            invalidateOnRefresh: vars.invalidateOnRefresh,
            onUpdate: function(self) {
              scrubTrigger = self;
              scrubFromProgress(self.progress);
              state.currentStage = self.progress * 2;
              updateCarouselPositions();
            }
          }
        });
        scrubTrigger = tl.scrollTrigger;
        addGolfTweens(tl);

        return function() {
          if (tl.scrollTrigger) tl.scrollTrigger.kill();
          tl.kill();
          scrubTrigger = null;
        };
      }

      mm.add('(max-width: 768px)', function() {
        return buildGolfPin({
          anticipatePin: 0,
          scrub: 0.3,
          invalidateOnRefresh: false
        });
      });
      mm.add('(min-width: 769px)', function() {
        return buildGolfPin({
          anticipatePin: 1,
          scrub: 1,
          invalidateOnRefresh: false
        });
      });
    });
  }

  // Start after page assets settle so desktop pin measurements remain stable.
  // 页面资源稳定后再启动，确保桌面端钉住位置测量准确。
  if (document.readyState === 'complete') {
    whenGSAPReady(initAllAnimations);
  } else {
    window.addEventListener('load', function() {
      whenGSAPReady(initAllAnimations);
    }, { once: true });
  }
})();